<template>
    <div class="mt-4">
        <slot name="title" :locale="locale">
            <div class="section-title"
                 v-html="trans[locale].create_section_title"
            >
            </div>
        </slot>
        <div class="form-group row" v-if="with_notification">
            <label class="col-sm-3 col-form-label">{{ trans[locale].push_notification }}</label>
            <div class="col-sm-6">
                <label class="custom-cb mb-4">
                    <input type="checkbox" v-model="selected_push_notification">
                    <span class="checkmark"></span>
                </label>
                <template v-if="selected_push_notification">
                <div class="input-group mb-2">
                    <div class="form-check form-check-inline">
                        <label class="custom-cb">
                            <input type="radio" v-model="selected" name="notification_option" value="on_issue_time"> <span class="checkmark"></span> {{ issue_when_approval ? trans[locale].approval_and_send : trans[locale].on_issue_time }}
                        </label>
                    </div>
                    <div class="form-check form-check-inline">
                        <label class="custom-cb">
                            <input type="radio" v-model="selected" name="notification_option" value="specific_time"> <span class="checkmark"></span> {{ trans[locale].specific_time }}
                        </label>
                    </div>
                </div>
                <div class="input-group mb-2" v-if="selected == 'specific_time'">
                    <datetime
                            name="message_send_time"
                            v-model="notification.message_send_time"
                            value-zone="local"
                            input-id="message_send_time"
                            type="datetime"
                            class="form-control"
                            :placeholder="trans[locale].please_select"
                            :title="trans[locale].specific_time"
                            :week-start="7"
                            format="yyyy-LL-dd HH:mm"
                            :auto="true"
                    >
                        <template slot="button-cancel" slot-scope="scope">
                            {{ trans[locale].cancel }}
                        </template>
                        <template slot="button-confirm" slot-scope="scope">
                            {{ trans[locale].confirm }}
                        </template>
                    </datetime>
                </div>
                <div id="message_send_time_status"
                     class="invalid-feedback"
                     style="display:block !important;"
                     v-cloak
                     v-if="$store.getters.hasError('message_send_time')"
                     v-html="$store.getters.showError('message_send_time')"
                >
                </div>
                <slot name="remarks"></slot>
                <div class="alert-warning mt-2 p-1 remarks mt-0" v-if="with_reminder">
                    * {{ trans[locale].please_select_targets }}
                </div>
                </template>
            </div>
        </div>
        <div class="form-group row" v-if="with_publish_alert">
            <label class="col-sm-3 col-form-label">{{ trans[locale].publish_alert }}</label>
            <div class="col-sm-6 pt-2">
                <label class="custom-cb mb-4">
                    <input type="checkbox" v-model="reminder.publish_alert">
                    <span class="checkmark"></span>
                </label>
                <template v-if="reminder.publish_alert">
                    <div class="alert-warning mt-2 p-1 remarks mt-0">
                        * {{ trans[locale].send_at_start_date }}
                    </div>
                    <div id="publish_alert_status"
                         class="invalid-feedback"
                         style="display:block !important;"
                         v-cloak
                         v-if="$store.getters.hasError('publish_alert')"
                         v-html="$store.getters.showError('publish_alert')"
                    >
                    </div>
                </template>
            </div>
        </div>
        <div class="form-group row" v-if="with_reminder">
            <label class="col-sm-3 col-form-label">{{ trans[locale].reminder }}</label>
            <div class="col-sm-6 pt-2">
                <label class="custom-cb mb-4">
                    <input type="checkbox" v-model="reminder.unsigned_alert">
                    <span class="checkmark"></span>
                </label>
                <template v-if="reminder.unsigned_alert">
                    <multiselect label="name"
                                 track-by="key"
                                 :options="before_day_selected_options"
                                 :searchable="false"
                                 :multiple="false"
                                 :preselect-first="false"
                                 :allow-empty="false"
                                 :close-on-select="true"
                                 :show-labels="false"
                                 :placeholder="trans[locale].please_select"
                                 v-model="reminder.days_before_due_date">
                        <template slot="placeholder" slot-scope="props">
                            <span>{{ trans[locale].please_select }}</span>
                        </template>
                        <template slot="option" slot-scope="props">
                            <div>{{ props.option.name }}</div>
                        </template>
                        <template slot="noResult" slot-scope="props">
                            <span>No result</span>
                        </template>
                    </multiselect>
                    <div id="days_before_due_date_status"
                         class="invalid-feedback"
                         style="display:block !important;"
                         v-cloak
                         v-if="$store.getters.hasError('days_before_due_date')"
                         v-html="$store.getters.showError('days_before_due_date')"
                    >
                    </div>
                    <div class="alert-warning mt-2 p-1 remarks mt-0">
                        * {{ trans[locale].all_unsigned_targets }}
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>
<script>
    import {Datetime} from 'vue-datetime';
    import {helperTabs} from "../../mixins/helper.common";

    export default {
        mixins: [helperTabs],
        components: {
            Datetime,
        },
        data() {
            return Object.assign({
                locale: window.locale,
                trans: {
                    'zh-HK' : {
                        create_section_title: '推送訊息設定 (App)',
                        latest_section_title: '推送通知的最後設置 (App)',
                        push_notification: '推送通知',
                        on_issue_time: '現在',
                        approval_and_send: '等待批核並同時推送通知',
                        specific_time: '指定時間',
                        cancel : '取消',
                        confirm : '確定',
                        please_select : '請選擇',
                        please_select_targets : '推送訊息(即時設定) - 必須從適用對象中選擇',
                        publish_alert : '最新電子通告提示',
                        reminder : '通告回覆提示',
                        send_at_start_date : '推送訊息(排程設定) - 發出日期當天的所有適用對象',
                        all_unsigned_targets : '推送訊息(排程設定) - 所有未簽署的適用對象',
                    },
                    'en' : {
                        create_section_title: 'Push Notification Settings (App)',
                        latest_section_title: 'Latest settings for push notification (App)',
                        push_notification: 'Push Notification',
                        on_issue_time: 'Now',
                        approval_and_send: 'Wait for approval and send notification at the same time',
                        specific_time: 'Specific Time',
                        cancel : 'Cancel',
                        confirm : 'Confirm',
                        please_select : 'Please select',
                        please_select_targets : 'Set up push notification in real time - Must choose from targets',
                        publish_alert : 'Reminder for latest eNotice alert',
                        reminder : 'Reminder for replying to Notices',
                        send_at_start_date : 'Set up push notification on schedule - All targets on issue date',
                        all_unsigned_targets : 'Set up push notification on schedule - All unsigned targets',
                    },
                },
                selected: null,
                selected_push_notification: this.init_selected_push_notification,
                notification: {
                    on_issue_time: this.init_on_issue_time,
                    specific_time: this.init_specific_time,
                    message_send_time: this.init_message_send_time,
                    selected_signatures: [],
                },
                reminder: {
                    unsigned_alert: false,
                    publish_alert: false,
                    days_before_due_date: null,
                },
                before_day_selected_options: this.init_days_before_options,
                issue_when_approval: this.init_issue_when_approval,
            }, __FORM__,{locale: window.locale});
        },
        props: {
            with_notification: {
                required: false,
                type: Boolean,
                default: true,
            },
            with_on_issue_time: {
                required: false,
                type: Boolean,
                default: false,
            },
            with_specific_time: {
                required: false,
                type: Boolean,
                default: false,
            },
            init_selected_push_notification: {
                required: false,
                type: Boolean,
                default: false,
            },
            init_on_issue_time: {
                required: false,
                type: Boolean,
                default: false,
            },
            init_specific_time: {
                required: false,
                type: Boolean,
                default: false,
            },
            init_message_send_time: {
                required: false,
                type: String,
                default: null,
            },
            callback: {
                required: false,
                type: String,
                default: 'retrieve-notifications',
            },
            toggle_select_target_callback: {
                required: false,
                type: String,
                default: 'toggle-select-targets',
            },
            init_issue_when_approval: {
                required: false,
                type: Boolean,
                default: false
            },
            with_publish_alert: {
                required: false,
                type: Boolean,
                default: false,
            },
            with_reminder: {
                required: false,
                type: Boolean,
                default: false,
            },
            init_days_before_due_date: {
                required: false,
                type: Number,
                default: () => {
                    return 2;
                }
            },
            init_days_before_options: {
                required: false,
                type: Array,
                default: () => {
                    return [];
                }
            },
        },
        beforeDestroy() {
            this.$root.$off('assign-targets-for-push-message', this.assignTargets);
            this.$root.$off('change-issue-when-approval', this.changeIssueWhenApproval);
        },
        beforeMount() {
            let self = this;
            if (self.reminder.unsigned_alert) {
                self.reminder.days_before_due_date = _.first(_.filter(self.init_days_before_options, (option) => {
                    return option.key == self.init_days_before_due_date;
                }));
            }
        },
        mounted() {
            let self = this;
            this.$root.$on('assign-targets-for-push-message', this.assignTargets);
            this.$root.$on('change-issue-when-approval', this.changeIssueWhenApproval);
            this.$nextTick(function(e) {
                if (this.init_specific_time && !_.isNull(this.init_message_send_time))
                {
                    this.selected = 'specific_time';
                } else {
                    this.selected = 'on_issue_time';
                }
                if (this.init_selected_push_notification) {
                    self.$root.emit(this.toggle_select_target_callback, self.init_selected_push_notification);
                }
            });
        },
        watch: {
            selected_push_notification() {
                this.$root.emit(this.toggle_select_target_callback, this.selected_push_notification);
                if (this.selected_push_notification)
                {
                    if (!this.on_issue_time && !this.specific_time) {
                        this.selected = 'specific_time';
                    }
                    let target_container = document.getElementById('push_message_selected_target_container')
                    if (!_.isUndefined(target_container) && !_.isNull(target_container)) {
                        target_container.scrollIntoView();
                    }
                } else {
                    this.notification.on_issue_time = false;
                    this.notification.specific_time = false;
                }
            },
            selected() {
                if (this.selected == 'on_issue_time')
                {
                    this.notification.on_issue_time = true;
                    this.notification.specific_time = false;
                    this.notification.message_send_time = null;
                } else if (this.selected == 'specific_time') {
                    this.notification.on_issue_time = false;
                    this.notification.specific_time = true;
                }
            },
            notification: {
                handler(after, before) {
                    if (!_.isNull(this.callback))
                    {
                        this.$root.emit(this.callback, this.notification);
                    }
                },
                deep: true,
            },
            'reminder.unsigned_alert': {
                handler(value) {
                    let self = this;
                    if (this.reminder.unsigned_alert)
                    {
                        self.reminder.days_before_due_date = _.first(_.filter(self.init_days_before_options, (option) => {
                            return option.key == self.init_days_before_due_date;
                        }));
                    } else {
                        self.reminder.days_before_due_date = null;
                    }
                },
                deep: true,
            }
        },
        methods : {
            assignTargets(signatures) {
            },
            changeIssueWhenApproval(issue_when_approval) {
                this.issue_when_approval = issue_when_approval;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Notification/ModulePushNotification.vue